module.exports = __webpack_public_path__ + "static/media/css.56bdd399.svg";